import { makeStyles } from '@material-ui/core';
export const useStyles = makeStyles((theme) => ({
  txtFakeContainer: {
    border: `1px solid ${theme.palette.grey[400]}`,
    borderRadius: 8,
    height: '569px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  txtFakeContainerTitle: {
    color: theme.palette.text.hint,
    background: theme.palette.common.white,
    marginTop: -10,
    marginLeft: 8,
    fontSize: 12,
    paddingLeft: 4,
    paddingRight: 4,
  },
  txtFakeContent: {
    width: '100%',
    padding: 8,
    marginTop: 8,
    height: 'calc(100% - 32px)',
    overflow: 'auto',
  },

  dialogContainer: {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
  dialogContent: {
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'column',
  },
}));
